import React, { useState } from 'react';
import './index.less'

const Gauge = (props) => {
    const [stateValues, setStateValues] = useState([0, 100])
    const { rightPanelGaugeOffsetdBg, rightPanelGaugeOccupiedBg, rightPanelGaugeNeedle } = props
    React.useEffect(() => {
        const timer = setTimeout(() => {
            updateGauge()
            setStateValues(props.values)
        }, 600)
        return () => {
            clearTimeout(timer)
        };
    }, [props.values, updateGauge])

    const RADIUS = 75;
    const STROKE_WIDTH = 5;
    const GAUGE_DIAMETER = 2 * RADIUS * Math.PI; // Diameter of the circle
    const ARC_ANGLE = 110;
    const SQ_VIEW_BOX = 150;
    const ARC_ROTATE = (180 - ARC_ANGLE) / 2 + ARC_ANGLE;
    const FULL_DASH_LENG = GAUGE_DIAMETER * ((360 - ARC_ANGLE) / 360);
    let STROKE_DASH_ARRAY_TOTAL = [FULL_DASH_LENG, GAUGE_DIAMETER];

    const updateGauge = React.useCallback(() => {
        let occupiedPercent = (stateValues[0] / stateValues[1]); // get the percent occupied
        let occupiedArcLength = FULL_DASH_LENG * occupiedPercent;

        let strokeDasharrayOccupied = [occupiedArcLength, GAUGE_DIAMETER];// calculate the occupied value
        let needleAngle = ARC_ROTATE + ((360 - ARC_ANGLE) * occupiedPercent)
        return {
            strokeDasharrayOccupied: strokeDasharrayOccupied,
            needleAngle: needleAngle
        }
    }, [ARC_ROTATE, FULL_DASH_LENG, GAUGE_DIAMETER, stateValues])




    React.useEffect(() => {
        let txts = document.getElementsByClassName("txt")
        let rcts = document.getElementsByClassName("rct")
        for (let i = 0; i < txts.length; i++) {
            let txt = txts.item(i);
            let rct = rcts.item(i);
            var bbox = txt.getBBox()
            rct.setAttribute("x", bbox.x - 2)
            rct.setAttribute("y", bbox.y)
            rct.setAttribute("width", bbox.width + 2 * 2)
            rct.setAttribute("height", bbox.height)
        }
    })

    return (
        <React.Fragment>
            <svg className="livefeed-svg-gauge" xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${SQ_VIEW_BOX} ${SQ_VIEW_BOX}`}>
                <g className="gauge-arc" transform={`rotate(${ARC_ROTATE}, ${SQ_VIEW_BOX / 2}, ${SQ_VIEW_BOX / 2})`}>
                    <circle strokeLinecap="round" fill="none" cx="50%" cy="50%" r={RADIUS} strokeDasharray={STROKE_DASH_ARRAY_TOTAL}
                        stroke={rightPanelGaugeOffsetdBg.color} strokeWidth={STROKE_WIDTH}></circle>
                    <circle strokeLinecap="round" fill="none" cx="50%" cy="50%" r={RADIUS} strokeDasharray={updateGauge().strokeDasharrayOccupied}
                        stroke={rightPanelGaugeOccupiedBg.color} strokeWidth={STROKE_WIDTH}></circle>
                </g>
                <g className="needle" transform={`rotate(${updateGauge().needleAngle}, ${SQ_VIEW_BOX / 2}, ${SQ_VIEW_BOX / 2})`}>
                    <line strokeLinecap="round" stroke={rightPanelGaugeNeedle.color} strokeWidth="3" x1={SQ_VIEW_BOX / 2} y1={SQ_VIEW_BOX / 2} x2={SQ_VIEW_BOX - 15} y2={SQ_VIEW_BOX / 2}></line>
                    <circle cx={SQ_VIEW_BOX / 2} cy={SQ_VIEW_BOX / 2} r="11" fill={rightPanelGaugeNeedle.color}
                        stroke="none">
                    </circle>
                </g>
            </svg >
            <svg className="livefeed-svg-gauge-label" xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${SQ_VIEW_BOX} ${SQ_VIEW_BOX}`} style={{ position: "absolute" }}>
                <g
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.setCurrentEntitySwitch(e)}
                >
                    <rect
                        className="rct"
                        x={SQ_VIEW_BOX / 4}
                        y={100}
                        width={SQ_VIEW_BOX / 2}
                        height={40}
                        style={{
                            stroke: props.widgetStyle.borderColor,
                            strokeWidth: 1,
                            strokeDasharray: props.currentEntity.id === "rightPanelGaugeValueLabel" ? "1 0" : "1 1",
                            fill: "none"
                        }} />
                    <text
                        className="txt"
                        data-tip="Click and choose toolbar options to change text style"
                        style={{
                            fill: props.widgetStyle.color,
                            fontSize: props.widgetStyle.fontSize,
                            fontWeight: props.widgetStyle.fontWeight,
                            fontStyle: props.widgetStyle.fontStyle,
                            textDecoration: props.widgetStyle.textDecoration
                        }}
                        x={SQ_VIEW_BOX / 2}
                        y={SQ_VIEW_BOX / 2 + 50}
                    >
                        {props.widgetLabelType ? `${stateValues[0]}/${stateValues[1]}` : `${stateValues[0]}`}
                    </text >
                </g>
            </svg>

        </React.Fragment>
    )
}
export default Gauge


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/common/Gauge/index.jsx